import type { FCC } from '@bnetex/shared/types';
import { useEffect, useMemo, useState } from 'react';
import { getOrRegisterServiceWorker } from '../lib/firebaseSw';
import { firebase } from '../lib/firebaseApp';
import type { FirebaseContextProps, FirebaseRegisterFunction } from '../lib/firebaseContext';
import { FirebaseContext } from '../lib/firebaseContext';
import { getToken } from 'firebase/messaging';

export const FirebaseProvider: FCC = ({ children }) => {
    const [ token, setToken ] = useState<string>();
    const [ isLoading, setIsLoading ] = useState(false);
    const { messaging, publicVapid } = firebase;

    const registerFirebaseToken: FirebaseRegisterFunction = async () => {
        setIsLoading(true);

        const worker = await getOrRegisterServiceWorker();
        if (!worker) return Promise.reject();

        try {
            const firebaseToken = await getToken(messaging, {
                vapidKey: publicVapid,
                serviceWorkerRegistration: worker,
            });

            setToken(firebaseToken);
            setIsLoading(false);
            return [ 'granted', firebaseToken ];
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            setIsLoading(false);
            return [ 'denied' ];
        }
    };

    useEffect(() => {
        if (window?.Notification?.permission === 'granted') {
            registerFirebaseToken();
        }
    }, []);

    const props: FirebaseContextProps = useMemo(() => ({
        token,
        isLoading,
        registerFirebaseToken,
    }), [ token, isLoading ]);

    return (
        <FirebaseContext.Provider value={props}>
            {children}
        </FirebaseContext.Provider>
    );
};
